import * as React from "react";
import DriversList from "../components/DriversList";
import DriverPanel from "../components/DriverPanel";
import ListSuccessMessage from "../../common/layout/ListSuccessMessage";
import { mergeStyles } from "office-ui-fabric-react";
import SMSHistoryPanel from "../components/SMSHisotryPanel";

const padding = mergeStyles({
  paddingTop: 15
})

const wrapper = mergeStyles({
  width: "95%",
  margin: "0px auto",
});


const Drivers: React.FC = () => {
  return (
    <div className={wrapper}>
      <div className={padding}> 
        <ListSuccessMessage/>
      </div>
      <DriversList />
      <DriverPanel />
      <SMSHistoryPanel />
    </div>
  );
};

export default Drivers;
